var map = {
	"./bear1.svg": "cfdb",
	"./bear2.svg": "8cf9",
	"./bear3.svg": "36ab",
	"./bear4.svg": "ca71",
	"./bear5.svg": "8a34",
	"./bear6.svg": "a479",
	"./bear7.svg": "b480",
	"./bear8.svg": "bdad",
	"./bear9.svg": "9fbb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e246";